<template>
  <div class="custom-content" v-html="sanitizedContent"></div>
</template>

<script>
import { sanitize, addHook } from 'dompurify';
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    content: {
      type: String,
      required: true,
    },
  },
  created() {
    addHook('afterSanitizeAttributes', node => {
      // If anchor has target attribute, add the rel attribute to prevent tabnabbing attacks
      if ('target' in node) {
        node.setAttribute('rel', 'noopener noreferrer');
      }
    });
    this.sanitizedContent = sanitize(this.content, { ADD_TAGS: ['iframe'], ADD_ATTR: ['target'] });
  },
  data() {
    return {
      sanitizedContent: null,
    };
  },
});
</script>
